export default __webpack_public_path__ + "static/media/DLD.521a328f.png";